import React, { Component } from 'react'
import gql from 'graphql-tag'

import { graphql } from '@apollo/client/react/hoc'
import moment from 'moment-timezone'
import { FormText, Card, CardBody, CardText, Row, Col, Alert, Progress, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Badge } from 'reactstrap'
import PriceList from '../Reservations/PriceList'
import './NewAgreementPrice.css'
import UpdateAgreementPlan from './UpdateAgreementPlan'
import UpdateAgreementPromoPlanModal from './UpdateAgreementPromoPlan'
import ConfirmationPopup from './ConfirmationPopup'
import { CancelAgreementPromoMutation } from '../Drivers/Driver/Detail/Mutations'

import withApolloClient from '../withApolloClient'


const RentalDetailQuery = gql`query Rental($id: ID!){
    rental(id: $id){
        id
        stage
        car{
            id
        }
        branch{
            id
            tenant{
                id
                customId
            }
        }
        type{
            id
            chargeFrequency
            chargeFrequencyUnit
        }
        agreementpriceSet{
            edges{
                node{
                    id
                    price
                    minimumPrice
                    maximumPrice
                    interval
                    intervalUnit
                    currency { code symbol }
                    tierType
                    startDate
                    isActive
                    createdBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    updatedBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    tiers{
                        edges{
                            node{
                                id
                                price
                                interval
                                intervalUnit
                                currency { code symbol }
                                upperLimit
                                upperLimitUnit
                            }
                        }
                    }
                }
            }
        }

        agreementpromoSet{
            edges{
                node{
                    title
                    promoPrice
                    minimumPromoPrice
                    maximumPromoPrice
                    interval
                    intervalUnit
                    currency { code symbol }
                    id
                    startDate
                    expirationDate
                    isPending
                    isActive
                    isPercentage
                    cycle
                    minCycle
                    maxCycle
                    remainingCycles
                    createdBy {
                        id
                        username
                        firstName
                        lastName
                    }
                    updatedBy {
                        id
                        username
                        firstName
                        lastName
                    }
                }
            }
        }
    }
}`

const CreateAgreementPriceMutation = gql`
mutation createAgreementPriceMutation($input: CreateAgreementPriceMutationInput!){
    createAgreementPrice(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const CreateAgreementPromoMutation = gql`
mutation createAgreementPromoMutation($input: CreateAgreementPromoMutationInput!){
    createAgreementPromo(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const RemoveAgreementPromoMutation = gql`
mutation removeAgreementPromoMutation($input: RemoveAgreementPromoMutationInput!){
    removeAgreementPromo(input:$input){
        ok
        errors{
            messages
        }
    }
}`

const UpdateAgreementPromoMutation = gql`mutation updateAgreementPromoMutation($input: UpdateAgreementPromoMutationInput!){
    updateAgreementPromo(input:$input){
        ok
        errors{
            field
            messages
        }
        clientMutationId
    }
}`

const RemoveAgreementPriceMutation = gql`
mutation removeAgreementPriceMutation($input: RemoveAgreementPriceMutationInput!){
    removeAgreementPrice(input:$input){
        ok
        errors{
            messages
        }
    }
}`

const UpdateAgreementPriceMutation = gql`mutation updateAgreementPriceMutation($input: UpdateAgreementPriceMutationInput!){
    updateAgreementPrice(input:$input){
        ok
        errors{
            field
            messages
        }
        clientMutationId
    }
}`

class NewAgreementPrice extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            error: "",
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        this.setState({ [name]: value })
    };

    refetchQuery = () => {
        this.props.refetchReservationQuery()
    }

    compareTemplatesDate = (a, b) => {
        if (a.node.startDate < b.node.startDate)
            return -1
        if (a.node.startDate > b.node.startDate)
            return 1
        return 0
    }

    handleClose = (e) => {
        let state = {
            loading: false,
            error: "",
        }
        this.setState({ ...state })
        this.props.handleClose()
        if (this.props.refetchQuery) {
            this.props.refetchQuery()
        }
    };

    handleCancelPromo = async (promoId) => {
        this.setState({
            openModal: "cancelPromo" + promoId,
            cancelPromoLoading: false,
            cancelPromoError: "",
            cancelPromoSuccess: ""
        })
    };

    confirmCancelPromo = async (promoId) => {
        this.setState({ loading: true, error: "", cancelPromoSuccess: "" })

        try {
            const client = this.props.apolloClient || this.props.client
            if (this.props.hasPermissions && !this.props.hasPermissions.includes("custom_can_cancel_agreement")) {
                this.setState({
                    error: "You don't have permission to deactivate this promo",
                    loading: false
                })
                return
            }

            if (!client) {
                this.setState({
                    cancelPromoError: "Apollo client not available",
                    loading: false
                })
                return
            }

            const result = await client.mutate({
                mutation: CancelAgreementPromoMutation,
                variables: {
                    input: {
                        agreementPromo: promoId,
                    }
                },

            })

            if (result.data && result.data.cancelAgreementPromo && result.data.cancelAgreementPromo.ok) {
                this.setState({
                    cancelPromoSuccess: "Promo deactivated successfully!",
                    loading: false
                })

            } else {
                const errors = result.data?.cancelAgreementPromo?.errors || []
                const errorMessages = errors.map(error => error.messages).flat().join(', ')
                this.setState({
                    error: errorMessages || "Failed to deactivate this promo",
                    loading: false
                })
            }
        } catch (error) {
            console.error('Error canceling promo:', error)
            this.setState({
                cancelPromoError: error.message || "An error occurred while cancelling the promo",
                cancelPromoLoading: false
            })
        }
    };

    handleCloseCancelPromoPopup = () => {
        this.setState({
            openModal: "",
            cancelPromoError: "",
            cancelPromoSuccess: "",
            cancelPromoLoading: false
        })
    };

    updateAgreementPlan = (action = "add", plan, e) => {
        this.setState({ loading: true })
        let input
        if (action === "add") {
            if (((this.props.rental && this.props.rental.branch && this.props.rental.branch.tenant && this.props.rental.branch.tenant.customId === "mnave")) &&
                ((this.props.rental && this.props.rental.agreementpriceSet && this.props.rental.agreementpriceSet.edges && this.props.rental.agreementpriceSet.edges.length > 0))
            ) {
                this.setState({ error: "Unable to add a new pricing template. Only one pricing template can be active at a time.", loading: false })
                return
            }
            const startDate = moment().add(1, 'days').tz("America/New_York").format(moment.HTML5_FMT.DATE)
            input = {
                agreement: this.props.rental.id,
                price: parseFloat(plan.price),
                minimumPrice: parseFloat(plan.minimumPrice),
                maximumPrice: parseFloat(plan.maximumPrice),
                interval: plan.interval,
                intervalUnit: plan.intervalUnit.charAt(0).toUpperCase() + plan.intervalUnit.substr(1).toLowerCase(),
                startDate: startDate,
                tierType: plan.tierType && plan.tiers.edges.length > 0 ? plan.tierType.charAt(0).toUpperCase() + plan.tierType.substr(1).toLowerCase() : null,
                tiers: plan.tierType && plan.tiers.edges.length > 0 && plan.tiers.edges.map(tier => { return tier.node.id })
            }
        } else if (action === "remove") {
            input = { agreementPrice: plan.id }
        } else if (action === "edit") {
            let { name, value } = e.target
            if (name.includes("selectedPlanStartDate"))
                input = {
                    agreementPrice: plan.id,
                    startDate: value
                }
            else if (name.includes("selectedPlanBasePrice"))
                input = {
                    agreementPrice: plan.id,
                    price: value
                }
        }
        if (action === "add" || action === "remove" || action === "edit") {
            this.props.apolloClient.mutate({
                mutation: action === "add" ? CreateAgreementPriceMutation : action === "remove" ? RemoveAgreementPriceMutation : action === "edit" ? UpdateAgreementPriceMutation : null,
                variables: { input },
            }).then((result) => {
                if (result && result.data &&
                    ((action === 'add' && result.data.createAgreementPrice && result.data.createAgreementPrice.ok) ||
                        (action === 'remove' && result.data.removeAgreementPrice && result.data.removeAgreementPrice.ok) ||
                        (action === 'edit' && result.data.updateAgreementPrice && result.data.updateAgreementPrice.ok))) {
                    this.refetchQuery()
                    this.setState({ loading: false, error: "" })
                } else {
                    let error = ""
                    if (result && result.data && action === 'add' && result.data.createAgreementPrice && result.data.createAgreementPrice.errors && result.data.createAgreementPrice.errors) {
                        result.data.createAgreementPrice.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                    } else if (result && result.data && action === 'remove' && result.data.removeAgreementPriceremoveAgreementPricez && result.data.removeAgreementPrice.errors && result.data.removeAgreementPrice.errors) {
                        result.data.removeAgreementPrice.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                    } else if (result && result.data && action === 'edit' && result.data.updateAgreementPrice && result.data.updateAgreementPrice.errors && result.data.updateAgreementPrice.errors) {
                        result.data.updateAgreementPrice.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                    } else {
                        error = "An error has occured. Please contact admin."
                    }
                    this.setState({ loading: false, error: error })
                }
            }).catch((err) => {
                this.setState({ loading: false, error: "An error has occured. Please contact admin." })
            })
        }
    }

    updateAgreementPromoPlan = (action = "add", plan, e) => { // action can be add/remove/edit
        let input
        if (action === "edit") {
            let { name, value } = e.target
            if (name.includes("selectedPromoStartDate"))
                input = {
                    agreementPromo: plan.id,
                    startDate: value
                }
            else if (name.includes("selectedPromoPrice"))
                input = {
                    agreementPromo: plan.id,
                    promoPrice: value
                }
            else if (name.includes("selectedPromoExpirationDate"))
                input = {
                    agreementPromo: plan.id,
                    expirationDate: value
                }
        }
        else if (action === "add") {
            // plan.startDate = moment().add(1,'days').tz("America/New_York").format(moment.HTML5_FMT.DATE);

            input = {
                agreement: this.props.rental.id,
                title: plan.title,
                promoPrice: plan.promoPrice,
                minimumPromoPrice: plan.minimumPromoPrice,
                maximumPromoPrice: plan.maximumPromoPrice,
                cycle: plan.cycle,
                minCycle: plan.minCycle,
                maxCycle: plan.maxCycle,
                isPercentage: plan.isPercentage,
                interval: plan.interval,
                intervalUnit: plan.intervalUnit.charAt(0).toUpperCase() + plan.intervalUnit.substr(1).toLowerCase(),
                startDate: plan.startDate,
                expirationDate: plan.expirationDate
            }
        }
        else if (action === "remove") {
            input = {
                agreementPromo: plan.id,
            }
        }
        this.props.apolloClient.mutate({
            mutation: action === "add" ? CreateAgreementPromoMutation : action === "remove" ? RemoveAgreementPromoMutation : action === "edit" ? UpdateAgreementPromoMutation : null,
            variables: { input },
        }).then((result) => {
            if (result && result.data &&
                ((action === 'add' && result.data.createAgreementPromo && result.data.createAgreementPromo.ok) ||
                    (action === 'remove' && result.data.removeAgreementPromo && result.data.removeAgreementPromo.ok) ||
                    (action === 'edit' && result.data.updateAgreementPromo && result.data.updateAgreementPromo.ok))) {
                this.refetchQuery()
                this.setState({ loading: false, error: "" })
            } else {
                let error = ""
                if (result && result.data && action === 'add' && result.data.createAgreementPromo && result.data.createAgreementPromo.errors && result.data.createAgreementPromo.errors) {
                    result.data.createAgreementPromo.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                } else if (result && result.data && action === 'remove' && result.data.removeAgreementPromo && result.data.removeAgreementPromo.errors && result.data.removeAgreementPromo.errors) {
                    result.data.removeAgreementPromo.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                } else if (result && result.data && action === 'edit' && result.data.updateAgreementPromo && result.data.updateAgreementPromo.errors && result.data.updateAgreementPromo.errors) {
                    result.data.updateAgreementPromo.errors.map((item, i) => item.messages ? error += item.messages.join(". ") : "")
                } else {
                    error = "An error has occured. Please contact admin."
                }
                this.setState({ loading: false, error: error })
            }
        }).catch((err) => {
            this.setState({ loading: false, error: "An error has occured. Please contact admin." })
        })
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }
    componentDidMount() {
        const { apolloClient } = this.props
    }
    //TODO: Agreement edit for promotions
    render() {
        const allTemplates = this.props.rental && this.props.rental.agreementpriceSet && this.props.rental.agreementpromoSet && this.props.rental.agreementpriceSet !== null &&
            this.props.rental.agreementpromoSet !== null && [...this.props.rental.agreementpriceSet.edges, ...this.props.rental.agreementpromoSet.edges]
        return (
            <div>
                <Modal className="NewAgreementPrice" isOpen={this.props.open}>
                    {this.props.rental &&
                        <>
                            <ModalHeader>Customize Agreement Pricing Plans</ModalHeader>
                            <ModalBody>
                                {this.state.loading && <Row><Col xs={12}><Progress animated color="info" value={100} /></Col></Row>}

                                <PriceList updatePlan={this.updateAgreementPlan} updatePromoPlan={this.updateAgreementPromoPlan} agreementTypeId={this.props.rental.type ? this.props.rental.type.id : ""} carId={this.props.rental.car ? this.props.rental.car.id : ""} />
                                {/* {this.props.allTemplates && this.props.allTemplates.edges.length > 0 && (this.props.allTemplates.edges).sort(this.compareTemplatesDate).map((agreementPlan,i)=> */}
                                {allTemplates && allTemplates.length > 0 && (allTemplates).sort(this.compareTemplatesDate).map((agreementPlan, i) =>

                                    <Col xs={12} key={i}>
                                        <Card className={agreementPlan.node.isActive ? "plan-detail-card" : "promo-detail-card"}>
                                            <CardBody>
                                                <Row>
                                                    <Col xs={4}>
                                                        <FormGroup>
                                                            {agreementPlan.__typename === "AgreementPromoNodeEdge" &&
                                                                <>
                                                                    <Label for={"selectedPromoPrice" + i}>Promo Base&nbsp;&nbsp;
                                                                        {agreementPlan?.node?.isActive ? (agreementPlan?.node?.isPending ? <Badge color="secondary">Pending</Badge> : <Badge color="primary">Active</Badge>) : <Badge color="danger">Inactive</Badge>}
                                                                        {agreementPlan?.node?.isPending && <span id={"base" + i} className="pl-4">
                                                                            <i onClick={() => this.toggleModal("promoPriceEdit" + i)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                                        </span>}
                                                                    </Label>
                                                                    <p style={{ "fontSize": "1rem", "marginBottom": "auto" }}>
                                                                        <b>{agreementPlan.node.isPercentage ? agreementPlan.node.promoPrice + '%' : '$' + agreementPlan.node.promoPrice}</b>
                                                                    </p>
                                                                    <FormText className="mt-0">{agreementPlan.node.currency ? agreementPlan.node.currency.code.toUpperCase() : "USD"} per {agreementPlan.node.interval && agreementPlan.node.interval > 1 ? agreementPlan.node.interval : ""}{agreementPlan.node.intervalUnit ? agreementPlan.node.intervalUnit : ""} every {this.props.rental.type ? ` ${this.props.rental.type.chargeFrequency} ${this.props.rental.type.chargeFrequencyUnit}` : '--'}</FormText>
                                                                    {this.state.openModal === "promoPriceEdit" + i && <UpdateAgreementPromoPlanModal agreementPlan={agreementPlan.node} title="Edit Agreement Promo Plan" name="promoPrice" isPercentage={agreementPlan.node.isPercentage} value={agreementPlan.node.promoPrice} target={"base" + i} id="base" type="number"
                                                                        open={this.state.openModal === "promoPriceEdit" + i} handleClose={() => this.toggleModal("")} refetchQuery={this.refetchQuery} />}
                                                                </>
                                                            }
                                                            {agreementPlan.__typename === "AgreementPriceNodeEdge" &&
                                                                <>
                                                                    <Label for={"selectedPlanBasePrice" + i}>Plan Base Price {agreementPlan.node.isActive && <Badge color="primary">Active</Badge>}
                                                                        {agreementPlan?.node?.isPending && <span id={"price" + i} className="pl-4">
                                                                            <i onClick={() => this.toggleModal("planBasePriceEdit" + i)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                                        </span>}
                                                                    </Label>
                                                                    <p style={{ "fontSize": "1rem", "marginBottom": "auto" }}><b>{agreementPlan.node.price}</b></p>
                                                                    <FormText className="mt-0">{agreementPlan.node.currency ? agreementPlan.node.currency.code.toUpperCase() : "USD"} per {agreementPlan.node.interval && agreementPlan.node.interval > 1 ? agreementPlan.node.interval : ""}{agreementPlan.node.intervalUnit ? agreementPlan.node.intervalUnit : ""} every
                                                                        {this.props.rental.type ? ` ${this.props.rental.type.chargeFrequency} ${this.props.rental.type.chargeFrequencyUnit}` : '--'}</FormText>
                                                                    {this.state.openModal === "planBasePriceEdit" + i && <UpdateAgreementPlan agreementPlan={agreementPlan.node} title="Edit Agreement Plan Price" name="price" value={agreementPlan.node.price} target={"price" + i} id="price" type="number"
                                                                        open={this.state.openModal === "planBasePriceEdit" + i} handleClose={() => this.toggleModal("")} refetchQuery={this.refetchQuery} />}
                                                                </>
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    {agreementPlan.__typename === "AgreementPromoNodeEdge" && <>
                                                        <Col xs={4}>
                                                            <FormGroup>
                                                                <Label for={"selectedPromoCycle" + i}>Total Cycle
                                                                    {agreementPlan?.node?.isPending && <span id={"cycle" + i} className="pl-4">
                                                                        <i onClick={() => this.toggleModal("planBaseCycleEdit" + i)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                                    </span>}
                                                                    <p style={{ "fontSize": "1rem", "marginBottom": "auto" }}>
                                                                        <b>
                                                                            {agreementPlan.node.cycle}
                                                                        </b>
                                                                    </p>
                                                                    {this.state.openModal === "planBaseCycleEdit" + i && <UpdateAgreementPromoPlanModal agreementPlan={agreementPlan.node} title="Edit Agreement Plan Cycle" name="cycle" value={agreementPlan.node.cycle} target={"cycle" + i} id="cycle" type="number"
                                                                        open={this.state.openModal === "planBaseCycleEdit" + i} handleClose={() => this.toggleModal("")} refetchQuery={this.refetchQuery} />}
                                                                </Label>
                                                            </FormGroup>
                                                        </Col>

                                                        <Col xs={4}>
                                                            <FormGroup>
                                                                <Label for={"selectedPromoCycle" + i}>Remaining Cycles
                                                                    <p style={{ "fontSize": "1rem", "marginBottom": "auto" }}>
                                                                        <b>
                                                                            {agreementPlan.node.remainingCycles}
                                                                        </b>
                                                                    </p>
                                                                </Label>
                                                            </FormGroup>
                                                        </Col>
                                                    </>
                                                    }
                                                    <Col xs={4}>
                                                        <FormGroup>
                                                            <Label for={"selectedPlanStartDate" + i}>Start Date</Label>
                                                            {agreementPlan.__typename === "AgreementPriceNodeEdge" &&
                                                                <Input name={"selectedPlanStartDate" + i} disabled={agreementPlan && agreementPlan.node && agreementPlan.node.startDate && moment().diff(agreementPlan.node.startDate, 'minutes') < 0 ? false : true} value={agreementPlan.node.startDate ? moment(agreementPlan.node.startDate).tz("America/New_York").format(moment.HTML5_FMT.DATE) : ""} onChange={(e) => this.updateAgreementPlan("edit", agreementPlan.node, e)} id={agreementPlan.node.id} min={moment().add(1, 'd').tz("America/New_York").format(moment.HTML5_FMT.DATE)} type="date" />
                                                            }
                                                            {agreementPlan.__typename === "AgreementPromoNodeEdge" &&
                                                                <>
                                                                    {agreementPlan.node.isPending && <span id={"startDate" + i} className="pl-4">
                                                                        <i onClick={() => this.toggleModal("planStartDateEdit" + i)} className={"fa fa-pencil-square-o"}></i>&nbsp;&nbsp;
                                                                    </span>}
                                                                    {this.state.openModal === "planStartDateEdit" + i && <UpdateAgreementPromoPlanModal agreementPlan={agreementPlan.node} title="Edit Agreement Promo Start Date" name="startDate" value={agreementPlan.node.startDate} target={"startDate" + i} id="startDate" type="date"
                                                                        open={this.state.openModal === "planStartDateEdit" + i} handleClose={() => this.toggleModal("")} refetchQuery={this.refetchQuery} />}
                                                                    <Input
                                                                        name={"selectedPromoStartDate" + i}
                                                                        disabled={true}
                                                                        value={
                                                                            agreementPlan.node.startDate
                                                                                ? moment(agreementPlan.node.startDate).tz("America/New_York").format(moment.HTML5_FMT.DATE)
                                                                                : ""
                                                                        }
                                                                        id={agreementPlan.node.id}
                                                                        type="date"
                                                                    />
                                                                </>
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    {agreementPlan.__typename === "AgreementPromoNodeEdge" &&
                                                        <Col xs={4}>
                                                            <FormGroup>
                                                                <Label for={"selectedPromoExpirationDate" + i}>Expiration Date</Label>
                                                                <Input
                                                                    name={"selectedPromoExpirationDate" + i}
                                                                    disabled={true}
                                                                    value={
                                                                        agreementPlan.node.expirationDate
                                                                            ? moment(agreementPlan.node.expirationDate).tz("America/New_York").format(moment.HTML5_FMT.DATE)
                                                                            : ""
                                                                    }
                                                                    onChange={(e) => this.updateAgreementPromoPlan("edit", agreementPlan.node, e)}
                                                                    id={agreementPlan.node.id}
                                                                    type="date"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    }

                                                    <Col xs={4}>
                                                        <FormGroup className="mb-0">
                                                            <Label for={"selectedPlanCreatedBy" + i} className="mb-0 pb-0">Created By</Label>
                                                            <p>{agreementPlan.node.createdBy ? agreementPlan.node.createdBy.firstName ? agreementPlan.node.createdBy.firstName + " " + agreementPlan.node.createdBy.lastName : agreementPlan.node.createdBy.username : "--"} </p>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <FormGroup className="mb-0">
                                                            <Label for={"selectedPlanupdatedBy" + i} className="mb-0 pb-0">Updated By</Label>
                                                            <p>{agreementPlan.node.updatedBy ? agreementPlan.node.updatedBy.firstName ? agreementPlan.node.updatedBy.firstName + " " + agreementPlan.node.updatedBy.lastName : agreementPlan.node.updatedBy.username : "--"} </p>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3">
                                                    {/* <Col xs={10}>
                                                        {agreementPlan.node.tierType && agreementPlan.node.tiers && agreementPlan.node.tiers.edges && agreementPlan.node.tiers.edges.length > 0 ?
                                                            <FormGroup className="plan-tiers">
                                                                <Label>Tiers {agreementPlan.node.tierType ? " - " + agreementPlan.node.tierType : ""}</Label>
                                                                {agreementPlan.node.tiers && agreementPlan.node.tiers.edges.length > 0 && agreementPlan.node.tiers.edges.map((tier, j) =>
                                                                    <CardText>{"$" + tier.node.price + " - " + tier.node.upperLimit + tier.node.upperLimitUnit}</CardText>
                                                                )}
                                                            </FormGroup>
                                                            : ""}
                                                    </Col> */}
                                                    {agreementPlan.__typename === "AgreementPromoNodeEdge" &&
                                                        <Col xs={4}>
                                                            {agreementPlan && agreementPlan.node && agreementPlan.node.startDate && moment().diff(agreementPlan.node.startDate, 'minutes') < 0 &&
                                                                <i className="fa fa-trash" onClick={(e) => this.updateAgreementPromoPlan("remove", agreementPlan.node, e)}>&nbsp;&nbsp;<span>Remove</span></i>
                                                            }
                                                            {agreementPlan && agreementPlan.node && agreementPlan.node.startDate && moment().diff(agreementPlan.node.startDate, 'minutes') > 0 && agreementPlan.node.isActive &&
                                                                <i className="fa fa-ban" aria-hidden="true" onClick={() => this.handleCancelPromo(agreementPlan.node.id)}>&nbsp;&nbsp;<span>Deactivate</span></i>
                                                            }
                                                            {this.state.openModal === `cancelPromo${agreementPlan.node.id}` && (
                                                                <ConfirmationPopup
                                                                    message={`Are you sure you want to deactivate the ${agreementPlan.node.title} promo?`}
                                                                    open={this.state.openModal === (`cancelPromo${agreementPlan.node.id}`)}
                                                                    confirmAction={() => this.confirmCancelPromo(agreementPlan.node.id)}
                                                                    handleClose={this.handleCloseCancelPromoPopup}
                                                                    action="Deactivate Promo"
                                                                    loading={this.state.loading}
                                                                    color="danger"
                                                                    error={this.state.error}
                                                                    success={this.state.cancelPromoSuccess}
                                                                />
                                                            )}
                                                        </Col>
                                                    }

                                                    {agreementPlan.__typename === "AgreementPriceNodeEdge" &&
                                                        <Col xs={4}>
                                                            {agreementPlan && agreementPlan.node && agreementPlan.node.startDate && moment().diff(agreementPlan.node.startDate, 'minutes') < 0 &&
                                                                <i className="fa fa-circle-o" onClick={(e) => this.updateAgreementPlan("remove", agreementPlan.node, e)}>&nbsp;&nbsp;<span>Remove</span></i>
                                                            }

                                                        </Col>
                                                    }

                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ) || <Col className="p-5 text-center text-danger" xs={12}><p>No plan has been selected for this agreement!</p></Col>}

                            </ModalBody>
                        </>}
                    <ModalFooter>
                        {this.state.error && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                        {!this.state.loading &&
                            <Row>
                                <Col xs={12}>
                                    <Button className="float-right" outline color="secondary" onClick={this.handleClose}>Close</Button>&nbsp;&nbsp;
                                </Col>
                            </Row>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}


export default graphql(RentalDetailQuery, {
    options: ({ rental }) => ({ variables: { id: rental.id } }),
    props: ({ data: { rental, loading, fetchMore, variables } }) => (
        {
            rental, loading, variables,
            refetchReservationQuery: () => {
                //No apollo function that refetches in place with pagination considered so this function instead
                return fetchMore({
                    query: RentalDetailQuery,
                    variables: {
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            rental: fetchMoreResult.rental
                        }
                    },
                })
            }
        }
    )
})(withApolloClient(NewAgreementPrice))
